import React, { useState } from 'react';

function ChurchModal({ church, onClose, onAddContact }) {
  const [showContactForm, setShowContactForm] = useState(false);
  const [contactData, setContactData] = useState({
    contact_method: 'email',
    notes: '',
    response_received: false,
  });

  const handleSubmitContact = async (e) => {
    e.preventDefault();
    await onAddContact(church.id, contactData);
    setContactData({
      contact_method: 'email',
      notes: '',
      response_received: false,
    });
    setShowContactForm(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{church.name}</h2>

        <div className="church-detail">
          <div className="detail-row">
            <span className="detail-label">Address:</span>
            <span className="detail-value">
              {church.address}<br />
              {church.city}, {church.state} {church.zip}
            </span>
          </div>

          {church.denomination && (
            <div className="detail-row">
              <span className="detail-label">Denomination:</span>
              <span className="detail-value">{church.denomination}</span>
            </div>
          )}

          {church.pastor_name && (
            <div className="detail-row">
              <span className="detail-label">Pastor:</span>
              <span className="detail-value">{church.pastor_name}</span>
            </div>
          )}

          {church.email && (
            <div className="detail-row">
              <span className="detail-label">Email:</span>
              <span className="detail-value">
                <a href={`mailto:${church.email}`}>{church.email}</a>
              </span>
            </div>
          )}

          {church.phone && (
            <div className="detail-row">
              <span className="detail-label">Phone:</span>
              <span className="detail-value">
                <a href={`tel:${church.phone}`}>{church.phone}</a>
              </span>
            </div>
          )}

          {church.website && (
            <div className="detail-row">
              <span className="detail-label">Website:</span>
              <span className="detail-value">
                <a href={church.website} target="_blank" rel="noopener noreferrer">
                  {church.website}
                </a>
              </span>
            </div>
          )}

          <div className="detail-row">
            <span className="detail-label">First Found:</span>
            <span className="detail-value">{new Date(church.found_date).toLocaleDateString()}</span>
          </div>
        </div>

        {/* Contact History */}
        <div className="contact-history">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3>Contact History</h3>
            <button 
              className="btn-primary"
              onClick={() => setShowContactForm(!showContactForm)}
            >
              {showContactForm ? 'Cancel' : '+ Add Contact'}
            </button>
          </div>

          {/* Add Contact Form */}
          {showContactForm && (
            <form onSubmit={handleSubmitContact} style={{ marginBottom: '1rem', padding: '1rem', background: '#f8f9fa', borderRadius: '4px' }}>
              <div className="filter-group" style={{ marginBottom: '1rem' }}>
                <label>Contact Method</label>
                <select
                  value={contactData.contact_method}
                  onChange={(e) => setContactData({ ...contactData, contact_method: e.target.value })}
                >
                  <option value="email">Email</option>
                  <option value="phone">Phone</option>
                  <option value="visit">Visit</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="filter-group" style={{ marginBottom: '1rem' }}>
                <label>Notes</label>
                <textarea
                  value={contactData.notes}
                  onChange={(e) => setContactData({ ...contactData, notes: e.target.value })}
                  rows={3}
                  style={{ width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '4px' }}
                  placeholder="What was discussed or sent..."
                  required
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
                <input
                  type="checkbox"
                  id="response_received"
                  checked={contactData.response_received}
                  onChange={(e) => setContactData({ ...contactData, response_received: e.target.checked })}
                />
                <label htmlFor="response_received">Received Response</label>
              </div>

              <button type="submit" className="btn-primary">Save Contact</button>
            </form>
          )}

          {/* Contact History List */}
          {church.contact_history && church.contact_history.length > 0 ? (
            <div>
              {church.contact_history.map((contact) => (
                <div key={contact.id} className="contact-entry">
                  <div className="date">{formatDate(contact.contact_date)}</div>
                  <div className="method">
                    {contact.contact_method}
                    {contact.response_received && ' ✓ Response Received'}
                  </div>
                  <div className="notes">{contact.notes}</div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <p>No contact history yet</p>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChurchModal;
